import React from "react";
import { CourseProgress } from "./CourseProgress";
import IconBadge from "../IconBadge";
import { formatPrice } from "../../utils/helperfunctions";
import { FaBook } from "react-icons/fa6";

const TeacherCourseCard = ({
  id,
  title,
  imageUrl,
  chaptersLength,
  price,
  progress,
  category,
}) => {
  return (
    <a
      href={`/dashboard/teacher/course/${id}/students`}
      className="group hover:shadow-sm transition overflow-hidden border rounded-lg p-3 h-full"
    >
      <div className="relative w-full aspect-video rounded-md overflow-hidden">
        <img
          className="object-cover w-full h-full"
          alt={title}
          src={imageUrl}
        />
      </div>
      <div className="flex flex-col pt-2">
        <div className="text-lg md:text-base font-medium group-hover:text-sky-700 transition line-clamp-2">
          {title}
        </div>
        <p className="text-xs text-muted-foreground">{category}</p>
        <div className="my-3 flex items-center gap-x-2 text-sm md:text-xs">
          <div className="flex items-center gap-x-1 text-slate-500">
            <IconBadge size="sm" icon={() => <FaBook className="icon" />} />
            <span>
              {chaptersLength} {chaptersLength === 1 ? "Chapter" : "Chapters"}
            </span>
          </div>
        </div>
        {progress ? (
          <CourseProgress
            size="sm"
            value={progress}
            variant={progress === 100 ? "success" : "default"}
          />
        ) : price === 0 ? (
          <p className="text-md md:text-sm font-medium text-slate-700">
            Free Course
          </p>
        ) : (
          <p className="text-md md:text-sm font-medium text-slate-700">
            {formatPrice(parseInt(price))}
          </p>
        )}
      </div>
    </a>
  );
};

export default TeacherCourseCard;
